import React from 'react';
import axios from 'axios';
import BoletasHonorariosForm from '../components/HonorariosForm';
import { API_BASE_URL } from '../config';
import { showError, showSuccess } from '../utils/alerts';

const componenteCargaHonorarios = ({ token, id_company }) => {
    const procesarHonorarios = async (token) => {
        try {
            await axios.post(
                `${API_BASE_URL}/api/procesar-honorarios`,
                { id_company },
                { headers: { Authorization: `Bearer ${token}` } }
            ); // Ruta que ejecuta archivoVentas.js  
            showSuccess('Registros de boletas de honorarios procesados correctamente');
        } catch (error) {
            console.error('Error al procesar los registros de honorarios', error);
            showError('Error al procesar los registros de honorarios');
        }
    };
    return (
        <div>
            <h1>Carga de Boletas de honorarios</h1>
            <BoletasHonorariosForm url={`${API_BASE_URL}/api/cargar-honorarios`} id_company={id_company} token={token} />
            <button onClick={() => procesarHonorarios(token)}>Procesar Boletas de Honorarios</button>
        </div>
    );
};

export default componenteCargaHonorarios;
